import React from 'react';
import { observer } from 'mobx-react-lite';
import chatStore from '../stores/chatStore';
import { useTheme } from '../theme/ThemeContext';

const ChatSearch = observer(() => {
    const { theme } = useTheme();
    const isDark = theme === 'dark';
    return (
        <input
            value={chatStore.searchQuery}
            onChange={(e) => chatStore.setSearchQuery(e.target.value)}
            placeholder="Поиск чатов"
            className={`w-full rounded-lg border px-3 py-2 text-sm outline-none ${
                isDark
                    ? 'border-white/10 bg-white/5 placeholder:text-white/40'
                    : 'border-black/10 bg-white placeholder:text-black/40'
            }`}
        />
    );
});

export default ChatSearch;
